export const PLANS_INDEX_TOUR = {
  id: "plans_index",
  steps: [
    {
      element: '[data-tour="plans-index-create"]',
      popover: {
        title: "Novo plano",
        description:
          "Crie os planos que seus clientes vão assinar, com preços, licenças, créditos e features.",
        side: "bottom",
      },
    },
    {
      element: '[data-tour="plans-index-list"]',
      popover: {
        title: "Seus planos",
        description: "Cada card é um plano. Clique para editar preços, licenças e créditos.",
        side: "top",
      },
    },
  ],
};
